/**
 * This is a TypeGen auto-generated file.
 * Any changes made to this file can be lost when this file is regenerated.
 */

export enum LanguageSkillLevel {
	Native = 0,
	C2 = 1,
	C1 = 2,
	B2 = 3,
	B1 = 4,
	A2 = 5,
	A1 = 6,
	Other = 7,
}
